import axios from 'axios';
import { getSentry } from '@/analytics/sentry';

export default {
    GET_INVITE_DATA(context, payload) {
        return getInviteData(context, payload);
    },

    LINK_USER(context, payload) {
        return linkUser(context, payload);
    },

    CREATE_USER(context, payload) {
        return createUser(context, payload);
    },
};

const getInviteData = async ({ commit }, {
    appName,
    inviteToken,
} = {}) => {
    commit('RETRIEVE_INVITE_DATA_START', {
        appName, inviteToken,
    });

    try {
        const tokenUrl = `${import.meta.env.VITE_ACCOUNT_SERVICE_URL}/api/v2/account/${appName}/invite`;
        const timeoutInMilli = 10000;

        const requestConfig = {};

        requestConfig.timeout = timeoutInMilli;

        axios.get(tokenUrl, requestConfig).then((response) => {
            if (response.data.valid) {
                const { company: companyName } = response.data;

                commit('RETRIEVE_INVITE_DATA_SUCCESS', { companyName });
            } else {
                commit('RETRIEVE_INVITE_DATA_FAILURE');
            }

            return {};
        }).catch((error) => {
            commit('RETRIEVE_INVITE_DATA_FAILURE');

            const sentry = getSentry();
            sentry.captureException(error);
        });

        return {};
    } catch (error) {
        commit('RETRIEVE_INVITE_DATA_FAILURE');

        const sentry = getSentry();
        sentry.captureException(error);

        return {};
    }
};

const createUser = async (_context, {
    firstName,
    lastName,
    username,
    password,
    recaptchaToken,
} = {}) => {
    // The endpoint will be hit by the Invite Sign up view when a user creates an account as part of the invite flow.
    // The endpoint will create the user and return a principal Id that can be used to link the user to the app they were invited to.
    const url = `${import.meta.env.VITE_ACCOUNT_CENTRAL_BFF_URL}/v1/invite-signup`;

    const body = {
        firstName,
        lastName,
        username,
        password,
    };

    const headers = { 'Content-Type': 'application/json' };

    if (recaptchaToken) {
        headers['x-keap-recaptcha-token'] = recaptchaToken;
    }

    const response = await axios.post(url, body, { headers, timeout: 10000 });

    return response.data;
};

const linkUser = async ({ state, commit }, {
    appName = state.appName,
    inviteToken = state.inviteToken,
} = {}) => {
    commit('LINK_ACCOUNT_START', {
        appName, inviteToken,
    });

    const sentry = getSentry();

    try {
        const tokenUrl = `${import.meta.env.VITE_ACCOUNT_SERVICE_URL}/api/v2/account/${appName}/invite:accept`;
        const timeoutInMilli = 10000;

        const requestConfig = {};

        requestConfig.timeout = timeoutInMilli;

        axios.post(tokenUrl, {}, requestConfig).then((response) => {
            const appType = response.data.app_type;

            commit('LINK_ACCOUNT_SUCCESS', { appType });
        }).catch((error) => {
            commit('LINK_ACCOUNT_FAILURE', error);
            sentry.captureException(error);
        });

        return {};
    } catch (error) {
        commit('LINK_ACCOUNT_FAILURE', error);
        sentry.captureException(error);

        return {};
    }
};
